module.exports = __webpack_public_path__ + "img/logo.92f541ab.png";